import { render, staticRenderFns } from "./ImportProduct.vue?vue&type=template&id=660f6e2b&scoped=true&"
import script from "./ImportProduct.vue?vue&type=script&lang=js&"
export * from "./ImportProduct.vue?vue&type=script&lang=js&"
import style0 from "./ImportProduct.vue?vue&type=style&index=0&id=660f6e2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f6e2b",
  null
  
)

export default component.exports